var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWytworzonezrolinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.81 55.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.41,30.04h5.41v-3.37c0-3.15-2.57-5.72-5.72-5.72h-6.57c-2.07,0-3.98.73-5.48,1.94v-1.23c0-2.29,1.87-4.16,4.16-4.16h4.62c3.15,0,5.72-2.57,5.72-5.72v-3.37h-5.41c-3.15,0-5.72,2.57-5.72,5.72v.14c-1.24.13-2.39.57-3.37,1.24v-4c4.81-3.94,2.96-8.38-.72-10.9l-.91-.61-.91.61c-3.71,2.54-5.51,6.97-.72,10.9v4c-.98-.67-2.13-1.1-3.37-1.24v-.14c0-3.15-2.57-5.72-5.72-5.72H3.28v3.37c0,3.15,2.57,5.72,5.72,5.72h4.62c2.29,0,4.16,1.87,4.16,4.16v1.23c-1.5-1.21-3.41-1.94-5.48-1.94h-6.57c-3.15,0-5.72,2.57-5.72,5.72v3.37h5.41c3.15,0,5.72-2.57,5.72-5.72v-.1h1.17c3.02,0,5.48,2.46,5.48,5.48v3.31H4.28v3.27h1.8l.43,3.44h25.79l.43-3.44h1.8v-3.27h-13.5v-3.31c0-3.02,2.46-5.48,5.48-5.48h1.17v.1c0,3.15,2.57,5.72,5.72,5.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.51,55.73h21.8l1.59-12.75H6.92l1.59,12.75Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWytworzonezrolinIcon);
export default __webpack_public_path__ + "static/media/Wytworzone z roślin_icon.3e4f1739c3ac241e9f2c2cba8f818a03.svg";
export { ForwardRef as ReactComponent };